var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVector1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "aboutLeadership_x5F_SVG",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    enableBackground: "new 0 0 17 17",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 7.866,
    y: 1.978,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 15.0829 -2.0786)",
    fill: "#1C75BB",
    width: 0.213,
    height: 0.213
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.272,
    y: 1.501,
    transform: "matrix(-0.7083 0.706 -0.706 -0.7083 10.3217 -1.0517)",
    fill: "#1C75BB",
    width: 0.213,
    height: 0.213
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.943,
    y: 2.265,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 20.5402 -3.7648)",
    fill: "#1C75BB",
    width: 0.213,
    height: 0.213
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.682,
    y: 3.923,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 12.7304 2.7855)",
    fill: "#1C75BB",
    width: 0.213,
    height: 0.213
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.09,
    y: 5.885,
    transform: "matrix(-0.7094 0.7048 -0.7048 -0.7094 23.3624 2.3497)",
    fill: "#1C75BB",
    width: 0.213,
    height: 0.213
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.748,
    y: 7.223,
    transform: "matrix(-0.706 0.7083 -0.7083 -0.706 16.8851 7.6491)",
    fill: "#1C75BB",
    width: 0.213,
    height: 0.213
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.32,
    y: 4.884,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 17.9139 2.5613)",
    fill: "#1C75BB",
    width: 0.213,
    height: 0.213
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.956,
    y: 3.248,
    transform: "matrix(-0.7094 0.7048 -0.7048 -0.7094 19.5659 -1.3584)",
    fill: "#1C75BB",
    width: 0.213,
    height: 0.213
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.317,
    y: 8.793,
    transform: "matrix(-0.7083 0.706 -0.706 -0.7083 15.5475 11.3736)",
    fill: "#1C75BB",
    width: 0.213,
    height: 0.213
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.708,
    y: 11.268,
    transform: "matrix(-0.7048 0.7094 -0.7094 -0.7048 28.2108 11.0109)",
    fill: "#1C75BB",
    width: 0.212,
    height: 0.213
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.87,
    y: 11.704,
    transform: "matrix(-0.7083 0.706 -0.706 -0.7083 21.9633 14.5444)",
    fill: "#1C75BB",
    width: 0.213,
    height: 0.213
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.678,
    y: 15.286,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 19.0517 22.8937)",
    fill: "#1C75BB",
    width: 0.213,
    height: 0.213
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.269,
    y: 13.694,
    transform: "matrix(-0.7048 0.7094 -0.7094 -0.7048 25.7745 16.8765)",
    fill: "#1C75BB",
    width: 0.213,
    height: 0.213
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.882,
    y: 15.235,
    transform: "matrix(-0.7094 0.7048 -0.7048 -0.7094 34.7254 16.3656)",
    fill: "#1C75BB",
    width: 0.213,
    height: 0.213
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.926,
    y: 11.388,
    transform: "matrix(-0.7083 0.706 -0.706 -0.7083 16.7111 16.0822)",
    fill: "#1C75BB",
    width: 0.213,
    height: 0.213
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.382,
    y: 8.822,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 25.9249 7.118)",
    fill: "#1C75BB",
    width: 0.213,
    height: 0.213
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.608,
    y: 5.876,
    transform: "matrix(-0.7083 0.706 -0.706 -0.7083 13.9841 6.1847)",
    fill: "#1C75BB",
    width: 0.213,
    height: 0.213
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.967,
    y: 4.005,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 21.8112 -0.8118)",
    fill: "#1C75BB",
    width: 0.213,
    height: 0.213
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BB",
    d: "M14.009,15.443H2.91l-0.05-0.051v-0.968l0.037-0.049l0.894-0.248l1.192-2.647L5.38,8.92l0.267-2.835 l0.09-1.956l-0.426-0.75L5.304,3.354v-1.77l0.051-0.05H5.87l0.049,0.05v0.763l0.887,0.887v-1.65l0.051-0.05h1.107l0.049,0.05v0.88 h0.893v-0.88l0.051-0.05h1.107l0.049,0.05v1.649L11,2.346V1.584l0.051-0.05h0.516l0.05,0.05v1.77l-0.007,0.025L11.182,4.13 l0.09,1.958l0.268,2.837l0.396,2.556l1.192,2.648l0.894,0.248l0.037,0.049v0.967L14.009,15.443z M2.96,15.342h10.998v-0.879 l-0.879-0.244l-0.033-0.027l-1.204-2.676l-0.004-0.014l-0.398-2.565l-0.269-2.842l-0.09-1.975l0.006-0.027l0.429-0.752V1.635H11.1 v0.733l-0.015,0.035L10.1,3.39L10.044,3.4l-0.03-0.047V1.635H9.006v0.879l-0.05,0.051H7.964L7.913,2.514V1.635H6.905v1.719 L6.875,3.4L6.821,3.39L5.835,2.403L5.819,2.368V1.635H5.403v1.706l0.428,0.752L5.838,4.12L5.747,6.093l-0.268,2.84l-0.398,2.569 l-0.004,0.014l-1.205,2.676L3.84,14.219l-0.88,0.244V15.342z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BB",
    d: "M14.008,15.443l-0.017-0.004l-4.513-1.578L9.37,13.85l-0.024-0.01l-4.545,1.6l-0.04-0.004L2.95,14.451 l-0.02-0.066l0.067-0.02l1.791,0.973l4.494-1.582l-1.408-1.982L7.87,11.723l0.043-0.029l3.885-0.243L8.896,7.002l0.002-0.058 l0.021-0.028l-3.23-0.868L5.651,6.002l0.033-0.05l2.574-0.926L5.771,4.165l-0.033-0.04l0.021-0.048l1.068-0.764l2.109-0.846 l0.049,0.007l1.107,0.84l0.92,0.657l-0.283-1.322l0.023-0.054l0.059,0.007l0.787,0.715l0.004,0.07l-0.07,0.003l-0.674-0.609 l0.274,1.271l0.001,0.005l0.026,0.02L11.18,4.11l-0.01,0.038l-1.08,1.407l1.143,0.396l0.033,0.046l-0.031,0.048L9.059,6.942 L9.025,6.944L9.023,6.943L8.998,6.978l2.932,4.489l0.004,0.049l-0.043,0.029l-3.882,0.244l1.375,1.936l0.015,0.002l0.104,0.037 l3.547,0.387l0.033,0.019l0.966,1.192l0.002,0.062L14.008,15.443z M9.919,13.91l3.938,1.377l-0.842-1.039L9.919,13.91z  M5.868,5.992L8.985,6.83l0.941-1.226L8.409,5.079L5.868,5.992z M10.025,5.639L9.132,6.804l1.943-0.801L10.025,5.639z  M8.559,5.024L9.992,5.52l1.068-1.393l-0.004-0.002L8.559,5.024z M5.896,4.103l2.513,0.87l2.55-0.917l-0.924-0.661L8.948,2.571 L6.874,3.4L5.896,4.103z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BB",
    d: "M11.834,11.406l-0.018-0.004L5.413,8.976L5.382,8.94l0.011-0.045l1.403-1.622L6.671,6.882L5.669,6 L5.656,5.942L6.072,4.99l-0.29-0.912l0.005-0.04l0.032-0.024L6.571,3.85l0.257-0.589l0.009-0.013L7.911,2.02l0.071-0.005 l0.005,0.07l-1.07,1.223L6.691,3.823l3.638-0.796h0.021l1.121,0.194l-0.465-0.829l0.001-0.053l0.517-0.783l0.069-0.014 l0.015,0.069l-0.5,0.759l0.5,0.894l-0.002,0.054l-0.051,0.021l-1.215-0.21L6.642,3.937l-0.463,1.06l0.58,1.829l5.108,4.492 l0.01,0.064L11.834,11.406z M5.515,8.907l6.081,2.306L6.817,7.01l0.082,0.26L6.89,7.317L5.515,8.907z M5.763,5.949l0.85,0.748 L6.118,5.136L5.763,5.949z M5.896,4.101l0.237,0.751l0.388-0.889L5.896,4.101z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BB",
    d: "M2.91,15.443l-0.047-0.035l0.031-0.063l5.007-1.674l0.039,0.002l3.044,1.597l1.979-1.082L7.351,7.917 L6.405,8.442L5.966,9.46l1.987,2.251l0.007,0.057l-0.049,0.027l-2.884-0.25L4.989,11.52l-0.004-0.045l0.863-1.996L5.394,8.962 L5.382,8.921l0.024-0.035l0.921-0.514l0.479-1.107l0.038-0.029l0.045,0.016L7.371,7.79l1.495-0.833L6.448,3.095l-0.64,1.012 L5.744,4.124L5.72,4.063l0.436-1.175l-0.759,0.53L5.335,3.415l-0.012-0.06l0.502-1.01l0.066-0.021L5.915,2.39L5.499,3.225 l0.73-0.51l0.059,0.001l0.016,0.057L5.979,3.649l0.427-0.676L6.448,2.95l0.043,0.023l2.488,3.975l0.006,0.039L8.961,7.019 L7.439,7.866l5.641,6.3l0.012,0.043l-0.023,0.035l-2.057,1.127h-0.049l-3.051-1.598l-4.986,1.666L2.91,15.443z M5.104,11.451 l2.691,0.232L5.922,9.563L5.104,11.451z M5.509,8.942l0.384,0.436l0.37-0.855L5.509,8.942z M6.866,7.376L6.471,8.292l0.811-0.451 L6.866,7.376z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BB",
    d: "M4.784,15.443L4.784,15.443l-0.039-0.021L3.787,14.2l-0.01-0.039l0.024-0.035l4.215-2.435l0.064,0.013 L8.079,11.77l-3.258,3.656L4.784,15.443z M3.901,14.186l0.886,1.129l3.011-3.379L3.901,14.186z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BB",
    d: "M13.092,14.221l-0.021-0.004l-5.114-2.361l-0.029-0.055l0.126-0.666l-4.196,3.076l-0.07-0.01l0.011-0.07 l4.282-3.139l0.77-4.089l0.032-0.038L8.93,6.874l2.523,2.041l0.02,0.043l-0.024,0.039L9.4,10.146l-1.229,0.901L8.033,11.78 l5.08,2.344l0.025,0.065L13.092,14.221z M8.932,7.004l-0.733,3.9l1.146-0.842l1.987-1.117L8.932,7.004z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#1C75BB",
    points: "7.917,13.77 7.874,13.744 7.891,13.676 11.809,11.314 11.877,11.33 11.859,11.398 7.942,13.762  "
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector1);
export default __webpack_public_path__ + "static/media/vector1.9e6097a2b4987048dd4f6f32d3be2c26.svg";
export { ForwardRef as ReactComponent };